import type { FC, ReactNode } from 'react'

import { SplitChars } from '@/components/motion/split-text'
import Img from '@/components/generals/img'
import { team } from '@/constants/content'
import { cn } from '@/lib/utils'

const Team: FC = (): ReactNode => {
    return (
        <section aria-labelledby='team-title' className='py-24 gutter md:py-36'>
            <div className='flex flex-wrap items-end justify-between gap-6'>
                <h2 id='team-title' data-reveal='chars' className='display-l uppercase'>
                    <SplitChars text='The people' />
                </h2>

                <p data-reveal='fade' className='label-mono text-ash'>
                    (03) — 14 people, 3 cities
                </p>
            </div>

            <ul className='mt-12 grid grid-cols-2 gap-x-3 gap-y-12 md:mt-16 lg:grid-cols-4 lg:gap-x-6'>
                {team.map((person, index) => (
                    <li key={person.name} className={cn('group', index % 2 === 1 && 'lg:mt-16')}>
                        <div data-reveal='image' className='relative aspect-[4/5] overflow-hidden bg-coal'>
                            <Img
                                src={person.image}
                                alt={person.alt}
                                sizes='(min-width: 1024px) 24vw, 50vw'
                                className='transition-transform duration-[1.4s] ease-expo-out group-hover:scale-105'
                            />
                        </div>

                        <span aria-hidden='true' className='mt-4 block h-px origin-left scale-x-0 bg-acid transition-transform duration-700 ease-expo-out group-hover:scale-x-100' />

                        <p data-reveal='fade' className='mt-3 title-sm text-bone'>
                            {person.name}
                        </p>

                        <p data-reveal='fade' className='mt-1 meta-mono text-ash'>
                            {person.role}
                        </p>
                    </li>
                ))}
            </ul>
        </section>
    )
}

export default Team
